import axios from "./request";
export const Login = (name, password, type) => {
  const data = new FormData();
  data.append("name", name);
  data.append("password", password);
  data.append("type", type);
  return axios.post("/login", data);
};
export const Register = (name, password, phone) => {
  const data = new FormData();
  data.append("name", name);
  data.append("password", password);
  data.append("phone", phone);
  data.append("head_portrait", "/avatar.png");
  return axios.post("/register", data);
};

export const VerifyUse = (type, phone, name) => {
  const data = new FormData();
  data.append("type", type);
  data.append("phone", phone);
  data.append("name", name);
  return axios.post("/verify_use", data);
};



// WEBPACK FOOTER //
// ./src/request/login.js